import React from "react";
import { Plural } from "@lingui/macro";
import { Supportive } from "@conserveit/blocks";
import { getActionsAssociatedState } from "../../utils";

const RuleGroupRow: React.FunctionComponent<
  Insite.Insights.ComposedInsight & { showSnoozed: boolean }
> = (props) => {
  const {
    latestLabel,
    site,
    hits,
    activeHits,
    averageDur,
    activeAverageDur,
    actionsCount,
    showSnoozed,
  } = props;

  const displayHits = showSnoozed ? hits : activeHits;
  const displayAverageDur = showSnoozed ? averageDur : activeAverageDur;

  const { Cell, MainText, allAssociated, displayTargetCount } =
    getActionsAssociatedState(props, showSnoozed);

  return (
    <React.Fragment>
      <Cell>
        <MainText>{latestLabel}</MainText>
      </Cell>
      <Cell>
        <MainText>{site.label}</MainText>
      </Cell>
      <Cell>
        <MainText>{site.state}</MainText>
      </Cell>
      <Cell>
        <MainText>
          {allAssociated ? (
            `All Associated (${displayTargetCount})`
          ) : (
            <Plural
              value={displayTargetCount}
              one={`${displayTargetCount} Equip`}
              other={`${displayTargetCount} Equips`}
            />
          )}
        </MainText>
        {actionsCount > 0 && <Supportive>{actionsCount} Associated</Supportive>}
      </Cell>
      <Cell>
        <MainText>
          <Plural
            value={displayHits}
            one={`${displayHits} Hit`}
            other={`${displayHits} Hits`}
          />
        </MainText>
        <Supportive>Avg. {displayAverageDur}hrs</Supportive>
      </Cell>
    </React.Fragment>
  );
};

export default React.memo(RuleGroupRow);
